import { type ApiResponse, estClient } from './estClient';

class InterestApi {
  async removeInterest(interestId: Interest['id']): Promise<void> {
    await estClient.post<ApiResponse<{ interest: Interest }>>(
      `/api/interest/${interestId}/loose`,
    );
  }

  get STATUS() {
    return {
      ACTIVE: 1,
      WON: 2,
      LOST: 3,
    } as const;
  }
}

export interface Interest {
  id: number;
  status: 1 | 2 | 3;
  opportunity_id: number;
  unit_id: string;

  /**
   * @example '2026-03-14'
   */
  created_date: string;

  /**
   * @example '2026-02-28 21:28:36.829400'
   */
  created_at: string;
  created_by: string;

  /**
   * @example '2026-02-28 21:28:36.829400'
   */
  updated_at: string;
  updated_by: number;

  /**
   * @example '2026-02-28 21:28:36.829400'
   */
  closed_at: string | null;
  closed_by: number | null;
}

export const interestApi = new InterestApi();
